import { render, staticRenderFns } from "./StepInstitution.vue?vue&type=template&id=31484894&scoped=true&"
import script from "./StepInstitution.vue?vue&type=script&lang=js&"
export * from "./StepInstitution.vue?vue&type=script&lang=js&"
import style0 from "./StepInstitution.vue?vue&type=style&index=0&id=31484894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31484894",
  null
  
)

export default component.exports